// extracted by mini-css-extract-plugin
export var arrow = "_co-1";
export var content = "_co-0";
export var highlighted = "_co-2";